import "./style.css";

import logoHumanResourse from "./img/logoHumanResourse.svg";
import LogoSdaia from "./img/LogoSdaia.jpg";
import LogoCommunicationSpace from "./img/LogoCommunicationSpace.svg";
import logoCouncilOfUniversities from "./img/logoCouncilOfUniversities.png";
import LogoMinistryOfHaij from "./img/LogoMinistryOfHaij.png";
import LogoMinistyOfEducation from "./img/LogoMinistyOfEducation.jpg";
import LogoMinistyOfHealth from "./img/LogoMinistyOfHealth.jpg";



import Pagination from './imamComponents/PaginationI'
import { useTranslation } from 'react-i18next';
import background from "./img/background1.webp"



import { useEffect, useState, ChangeEvent } from "react";

import { changeLanguage } from 'i18next';




import {
    Breadcrumbs,
    Button,
    Modal,
    Tag
} from "platformscode-react";
import {
    CalendarMinus02Icon,
    Briefcase01Icon,
    DocumentValidationIcon,
    Note01Icon,
    BookBookmark01Icon

} from "@hugeicons/react-pro";

import "moment-hijri";
import moment from "moment-hijri";



function App() {

    //for trnslation
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    useEffect(() => {
        const lang = i18n.language;
        document.documentElement.lang = lang;
        document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    }, [i18n.language])


    //handel click 

    const handleCardClick = (url) => {
        window.location.href = url;
    };

    const ImagesLogo = {
        logoHumanResourse: logoHumanResourse,
        LogoSdaia: LogoSdaia,
        LogoCommunicationSpace: LogoCommunicationSpace,
        logoCouncilOfUniversities: logoCouncilOfUniversities,
        LogoMinistryOfHaij: LogoMinistryOfHaij,
        LogoMinistyOfEducation: LogoMinistyOfEducation,
        LogoMinistyOfHealth: LogoMinistyOfHealth,

    };



    //conent of cards
    const items = t("SurveyCard.items", { returnObjects: true });

    const Carddata = Array.isArray(items) ? items.map((item) => ({

        entityName: item.entityNameSurvey,
        typeSurvey: item.typeSurvey,
        SectorSurvey: item.SectorSurvey,
        startDate: item.submissionDate,
        endDate: item.endDate,
        url: item.url,
        logo: ImagesLogo[item.logo]


    }))
        : [];



    const [selectedUrl, setSelectedUrl] = useState(null);







    //for text status in each card 
    const getStatusText = (startDate, endDate) => {
        const now = new Date();
        const start = new Date(startDate);
        const end = new Date(endDate);


        if (now < start) return t("statussoon");
        if (now > end) return t("statusend");
        return t("stutsactive");
    };


    //for color status in each card 
    const getStatusColor = (startDate, endDate) => {
        const now = new Date();
        const start = new Date(startDate);
        const end = new Date(endDate);

        if (now < start) return "warning"; // soon
        if (now > end) return "gray"; // end
        return "success"; // open
    };


    // Start page number 
    const itemsPerPage = 8;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = Carddata.slice(startIndex, endIndex);
    const paginate = (pageNumbers) => setCurrentPage(pageNumbers);
    // End page number 

    return (
        <>




            {/* Page Title */}

            < div className="page-title flex flex-col gap-[16px] lg:px-[80px] px-[var(--spacing-xl,16px)] bg-[var(--background-primary-25,#F7FDF9)] py-[45px] mb-[40px]"

                style={{
                    backgroundImage: `url(${background})`,
                    backgroundPosition: 'bottom center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }} >

                <h1 class="text-[var(--text-default,#161616)] text-[40px] leading-[60px] font-[600] tracking-[-0.96px]">
                    {t("Survey")}</h1>
                <p className="text-[var(--text-default,#161616)] text-[16px] font-[400] leading-[24px]  mb-[40px]">
                    {t("Survey.description")}
                </p>
            </div >






            {/* Body */}
            <main className="max-w-[1600px] mx-auto px-6">
                {selectedUrl && (
                    <div
                        className="fixed inset-0 z-[999] flex justify-center items-center modal-overlay"
                        onClick={(e) => {
                            if (e.target.classList.contains("modal-overlay")) {
                                setSelectedUrl(null);
                            }
                        }}
                    >
                        <div onClick={(e) => e.stopPropagation()}>


                            <Modal
                                name="shareLinkModal"
                                title={t("participationLink")}
                                show={true}
                                onClose={() => setSelectedUrl(null)}

                                featuredIconType="infoCircle"
                                featuredIconColor="brand"
                                featuredIconSize="lg"
                                featuredIconStyle="light"
                                featuredIconCircle
                                secondBtnPosition="right"
                                buttonsList={[
                                    {
                                        label: t("copyLink"),
                                        title: "Copy Link",
                                        onClick: () => {
                                            if (selectedUrl) {
                                                navigator.clipboard.writeText(selectedUrl);

                                            }
                                        }
                                    },
                                    {
                                        label: t("close"),
                                        title: "Close",
                                        onClick: () => setSelectedUrl(null),
                                    },
                                ]}
                            >
                                <div className="bg-gray-100 p-4 rounded-xl text-center">
                                    <a
                                        href={selectedUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-700 text-lg font-semibold break-words inline-block"
                                    >
                                        {selectedUrl}
                                    </a>
                                </div>
                            </Modal>
                        </div>
                    </div>
                )}
                <div className="grid grid-cols-14 gap-[32px] ">


                    <div className="col-span-14 xl:col-span-9 xl:order-2 order-1 ">
                        <section>
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 ">


                                {currentItems.map((item, index) => (
                                    <div
                                        key={index}
                                        className="card   hover:bg-[#F9FAFB]  "
                                        style={{
                                            border: '1px solid #D2D6DB',
                                            boxShadow: 'none',
                                            cursor: "default"
                                        }}
                                    >




                                        {/* for content inside card */}
                                        <div>
                                            <img src={item.logo} alt="شعار " className="h-[55px]" />
                                        </div>

                                        <div className="h-[32px]" />

                                        <div className="extra space-y-5 mb-[24px]">




                                            <div className="flex gap-[3px]">
                                                <Briefcase01Icon className="text-green-800" />
                                                <div className="flex flex-col gap-[3px]">
                                                    <p className="text-[var(--text-display,#1F2A37)] text-[16px] font-[600] leading-[24px] ">
                                                        {t("entityNameSurvey")}
                                                    </p>
                                                    <p className="text-[16px] font-[400] leading-[24px]">
                                                        {item.entityName}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="flex gap-[3px]">
                                                <DocumentValidationIcon className="text-green-800" />
                                                <div className="flex flex-col gap-[3px]">
                                                    <p className="text-[var(--text-display,#1F2A37)] text-[16px] font-[600] leading-[24px]">
                                                        {t("typeSurvey")}
                                                    </p>
                                                    <p className="text-[16px] font-[400] leading-[24px]">
                                                        {item.typeSurvey}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="flex gap-[3px]">
                                                <Note01Icon className="text-green-800" />
                                                <div className="flex flex-col gap-[3px]">
                                                    <p className=" text-[var(--text-display,#1F2A37)] text-[16px] font-[600] leading-[30px]">
                                                        {t("projectStatus")}
                                                    </p>
                                                    <Tag
                                                        color={getStatusColor(item.submissionDate, item.endDate)}
                                                        label={getStatusText(item.submissionDate, item.endDate)}
                                                        size="lg"
                                                    />
                                                </div>
                                            </div>

                                            <div className="flex gap-[3px]">
                                                <BookBookmark01Icon className="text-green-800" />
                                                <div className="flex flex-col gap-[3px]">
                                                    <p className="text-[var(--text-display,#1F2A37)] text-[16px] font-[600] leading-[24px]">
                                                        {t("SectorSurvey")}
                                                    </p>
                                                    <p className="text-[16px] font-[400] leading-[24px]">
                                                        {item.SectorSurvey}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="flex gap-[3px]">
                                                <CalendarMinus02Icon className="text-green-800" />
                                                <div className="flex flex-col gap-[3px]">
                                                    <p className="text-[var(--text-display,#1F2A37)] text-[16px] font-[600] leading-[24px]">
                                                        {t("projectPeriod")}
                                                    </p>
                                                    <p className="text-[16px] font-[400] leading-[24px]">
                                                        {item.startDate} {t("to")} {item.endDate}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex justify-end">
                                            <Button onClick={() => setSelectedUrl(item.url)} color="primary" size="lg">
                                                {t("more")}
                                            </Button>

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>
            </main>

            {/* Pagination */}
            <div className="flex justify-center pb-[20px] pt-[20px]">
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={Carddata.length}
                    paginate={paginate}
                />
            </div>



        </>
    );
}

export default App;
